import {
    CreateButton,
    DataTable,
    DateField,
    EditButton,
    ExportButton,
    List,
    ReferenceField,
    TextField
} from '@/components/admin';
import { Card } from '@/components/ui/card';
import { Calendar, DollarSign } from 'lucide-react';
import { StatusBadgeField } from '../documents/shared/StatusBadge';
import { TopToolbar } from '../layout/TopToolbar';

const BoMListActions = () => (
    <TopToolbar>
        <CreateButton />
        <ExportButton />
    </TopToolbar>
);

export const BoMList = () => {
    return (
        <List 
            actions={<BoMListActions />}
            sort={{ field: 'created_at', order: 'DESC' }}
            className="p-6"
        >
            <Card className="border-none shadow-sm overflow-hidden">
                <DataTable rowClick="show">
                    <DataTable.Col 
                        source="reference" 
                        label="BoM No." 
                        className="font-mono font-bold text-foreground"
                    />
                    <DataTable.Col label="Project">
                        <ReferenceField source="project_id" reference="projects" link={false}>
                            <span className="font-semibold text-blue-600">
                                <TextField source="name" />
                            </span>
                        </ReferenceField>
                    </DataTable.Col>
                    <DataTable.Col source="version" label="Ver." className="font-medium" />
                    <DataTable.Col 
                        label="Estimate"
                        render={(record) => (
                             <div className="flex items-center gap-1 font-bold text-green-700">
                                <DollarSign className="w-3 h-3" />
                                <span>{new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(record.total_estimated_cost)}</span>
                            </div>
                        )}
                    />
                    <DataTable.Col label="Status">
                        <StatusBadgeField source="status" />
                    </DataTable.Col>
                    <DataTable.Col label="Linked Design">
                        <ReferenceField source="design_request_id" reference="design_requests" link={false}>
                            <TextField source="reference" />
                        </ReferenceField>
                    </DataTable.Col>
                    <DataTable.Col label="Created">
                        <div className="flex items-center gap-2 text-muted-foreground text-xs">
                            <Calendar className="w-3 h-3" />
                            <DateField source="created_at" />
                        </div>
                    </DataTable.Col>
                    <DataTable.Col>
                        <EditButton />
                    </DataTable.Col>
                </DataTable>
            </Card>
        </List>
    );
};
